import { Brand } from "effect"

export type Route = Brand.Branded<string, "Route">
export const Route = Brand.nominal<Route>()

export const dashboard = Route("/")

export const chipsCheckDuplicates = Route("/chips/check-duplicates")

export const chipsIngestV1Seritag = Route("/chips/ingest-v1-seritag")

export const chipsIngestV2 = Route("/chips/ingest-v2")

export const chipsIngestV1 = Route("/chips/ingest-v1")

export const chipsMove = Route("/chips/move")

export const chipsMigrate = Route("/chips/migrate")

export const chipsCopy = Route("/chips/copy")

export const chipsGroups = Route("/chip-groups")

export const chipsGroupsNew = Route("/chip-groups/new")

export const chipGroupDetail = (id: string) => Route(`/chip-groups/${id}`)

export const v1TagConfig = Route("/chips/v1-config")

export const login = Route("/login")

export const logout = Route("/logout")

export const postcardsSetVideo = Route("/postcards/set-video")

export const solanaOrders = Route("/solana/orders")

export const solanaOrderDetail = (id: string) => Route(`/solana/orders/${id}`)

export const tagGroupsExplode = Route("/tag-groups/explode")

export const musicInviteUsers = Route("/music/invite-user")

export const musicChipRequests = Route("/music/chip-requests")

export const musicChipRequestDetail = (id: string) => Route(`/music/chip-requests/${id}`)

export const chartingProducts = Route("/charting-products")

export const chartingProductsNew = Route("/charting-products/new")

export const chartingProductDetail = (id: string) => Route(`/charting-products/${id}`)

export const chartingProductEdit = (id: string) => Route(`/charting-products/${id}/edit`)
